import { DecimalPipe } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { RouterLink } from "@angular/router";

import { RuntimePipe } from "../../pipes";
import { HealthRightComponent } from "../../shared/health-right/health-right.component";
import { HealthStatusIndicatorComponent } from "../../shared/health-status-indicator/health-status-indicator.component";
import { APIResults } from "src/app/sharedinterfaces";
declare const BrandVars;

@Component({
	selector: "app-fleet-summary",
	templateUrl: "./fleet-summary.component.html",
	styleUrls: ["./fleet-summary.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [RouterLink, HealthStatusIndicatorComponent, HealthRightComponent, DecimalPipe, RuntimePipe]
})
export class FleetSummaryComponent {
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	organization: APIResults.Organization;

	public brand = BrandVars;
}
